<template>
  <v-layout
    :class="[sortedActivities.length > 3 ? 'fade-out-right' : null]"
    class="client application-activities overview"
    justify-end
    row
  >
    <div class="pl-2" v-for="(activity, i) in sortedActivities" :key="`activity-${i}`">
      <v-tooltip bottom>
        <v-badge
          slot="activator"
          bottom
          left
          class="activity__badge"
          :color="themes.client.light.muted"
        >
          <v-icon slot="badge" v-if="activity.type === 'Application event'" dark small>
            mdi-arrow-right-bold
          </v-icon>
          <v-icon slot="badge" v-if="activity.type === 'Application note'" dark small>
            mdi-pencil
          </v-icon>
          <v-icon slot="badge" v-if="activity.type === 'Profile view'" dark small>
            mdi-eye
          </v-icon>
          <v-avatar size="40">
            <img
              v-if="activity.initiator"
              :src="activity.initiator.avatar || '/img/missing/avatars/original.png'"
              class="activity__avatar__image"
              :class="themes.client.light.muted"
              v-img-orientation-changer
            />
          </v-avatar>
        </v-badge>
        <span v-if="activity.type === 'Application event'">
          {{ activity && activity.initiator ? `${activity.initiator.fullName} moved` : 'Moved' }}
          application {{ activity.createdAt | inWords({ addSuffix: true }) }}
        </span>
        <span v-else-if="activity.type === 'Application note'">
          {{ activity && activity.initiator ? `${activity.initiator.fullName} made` : 'Made' }}
          application {{ activity.createdAt | inWords({ addSuffix: true }) }}
        </span>
        <span v-else-if="activity.type === 'Profile view'">
          {{ activity && activity.initiator ? `${activity.initiator.fullName} viewed` : 'Viewed' }}
          application {{ activity.createdAt | inWords({ addSuffix: true }) }}
        </span>
      </v-tooltip>
    </div>
  </v-layout>
</template>

<script>
// Helper
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
  props: { application: { type: Object, required: true } },

  computed: {
    sortedActivities() {
      if (!_.get(this, 'application.activitiesOverview')) return []

      const activities = JSON.parse(JSON.stringify(this.application.activitiesOverview))
      return activities
        .filter(a => {
          if (_.get(a, 'initiator.role') === 'Candidate') return false
          if (_.get(a, 'type') === 'Feedback request') return false
          if (_.get(a, 'type') === 'Application rating') return false

          return true
        })
        .sort(({ createdAt: a }, { createdAt: b }) => {
          if (new Date(a) < new Date(b)) return 1
          if (new Date(a) > new Date(b)) return -1
          return 0
        })
        .splice(0, 4)
    },
  },
}
</script>

<style lang="scss">
.client.application-activities.overview {
  &.fade-out-right {
    &::after {
      content: ' ';
      position: absolute;
      top: 25%;
      height: 60px;
      width: 30px;
      border-radius: 2rem;

      background: linear-gradient(to right, transparent 0%, #fff);
    }
  }

  .activity__badge span {
    bottom: -7px;
    left: -5px;
  }

  .activity__avatar__image {
    padding: 2px;
  }
}
</style>
